import script from "./AuthMobileLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthMobileLayout.vue?vue&type=script&setup=true&lang=js"

import "./AuthMobileLayout.vue?vue&type=style&index=0&id=12021499&lang=css"

const __exports__ = script;

export default __exports__